module.exports = __webpack_public_path__ + "static/media/waterford-logo-2.ff3f5074.png";